import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('goodStatusBadge');

    return {
        GOOD: t('good')
    };
};

export default useTranslation;
